import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import React, { Fragment } from "react";
import FontAwesome from "../fontAwesome/fontAwesome";
const CheckUnckeck = ({ value, title }) => {
  return (
    <Fragment>
      {value === 1 ? (
        <FontAwesome icon={faCheck} style={{ color: "green" }} />
      ) : (
        <FontAwesome icon={faTimes} style={{ color: "red" }} />
      )}{" "}
      {title}
      <br />
    </Fragment>
  );
};

export default CheckUnckeck;
